// extracted by mini-css-extract-plugin
module.exports = {"Popover":"Popover-1SN2c","slideInPopover":"slideInPopover-1Y2Jq"};